import GroupCreationForm from "@/src/components/groups/group-creation-form";

export default function GroupCreationScreen() {
  return <GroupCreationForm mode="create" />;
}
